import React from 'react';
import { Grid, Paper } from '@material-ui/core';
import { Captions } from 'components/Typography';
import styled from 'styled-components';

interface CaptionsType {
  color: string;
  weight: string;
  onClick?: Function;
}

export const InlineCaption = styled(({ isLeft, ...otherProps }) => (
  <Captions {...otherProps} />
))`
  margin-bottom: 0px !important;
  font-size: 13px !important;
  display: inline-block;
  margin-left: ${(props) => props.isLeft && '5px !important'};
  line-height: 19px !important;
  cursor: pointer;
`;

export const FilCaption = styled(Captions)<CaptionsType>`
  margin-bottom: 4px !important;
  font-size: 13px !important;
  line-height: 15px !important;
  opacity: 70%;
`;
export const IgnoreCaption = styled(Captions)<CaptionsType>`
  margin-bottom: 4px !important;
  line-height: 14px !important;
  text-align: end;
  cursor: pointer;
`;

export const EndAlignGrid = styled(Grid)`
  align-self: end;
`;

export const ArrowIcon = styled.img`
  float: right;
  cursor: pointer;
`;

export const OvalIcon = styled.img`
  height: 9px;
  width: 9px;
  margin-top: 6px;
`;

export const OvalGrid = styled(Grid)`
  flex-grow: 0 !important;
`;

export const NotificationsWrapper = styled(Paper)`
  background-color: rgba(0, 0, 0, 0.5) !important;
  margin-bottom: -12px;
  color: white !important;
  padding: 11px 19px;
  border-radius: 6px;
  box-sizing: border-box;
`;
